import { render, staticRenderFns } from "./update-profile.vue?vue&type=template&id=1c1fd461&scoped=true"
import script from "./update-profile.vue?vue&type=script&lang=js"
export * from "./update-profile.vue?vue&type=script&lang=js"
import style0 from "./update-profile.vue?vue&type=style&index=0&id=1c1fd461&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c1fd461",
  null
  
)

export default component.exports